import { Badge } from "@altimateai/lego";
import { UserIcon, UserGroupIcon } from "@/assets/icons";
import { Privacy } from "@/helpers/constants";
import { PrivacyLevel } from "@/types";

interface PrivacyBadgeProps {
  privacy: PrivacyLevel;
  size?: "sm" | "md" | "lg";
  variant?: "default" | "outline" | "secondary";
}

const PrivacyBadge = ({ 
  privacy, 
  size = "sm",
  variant = "outline"
}: PrivacyBadgeProps) => {
  const isPublic = privacy === Privacy.PUBLIC;
  
  const sizeClasses = {
    sm: "al-text-xs al-px-2 al-py-0.5",
    md: "al-text-sm al-px-2 al-py-1", 
    lg: "al-text-sm al-px-3 al-py-1"
  };

  return (
    <Badge 
      variant={isPublic ? "default" : variant}
      className={`al-flex al-items-center al-gap-1 al-w-fit ${sizeClasses[size]} ${
        isPublic 
          ? "al-bg-blue-100 al-text-blue-800 al-border-blue-200" 
          : "al-bg-gray-100 al-text-gray-700 al-border-gray-300"
      }`}
    >
      {isPublic ? (
        <UserGroupIcon className="al-w-3 al-h-3" />
      ) : (
        <UserIcon className="al-w-3 al-h-3" />
      )}
      {isPublic ? "Public" : "Private"}
    </Badge>
  );
};

export default PrivacyBadge;